import { create } from 'zustand'
import type { User, Session } from '@supabase/supabase-js'
import type { Profile, UserRole } from '@/types/database'

interface AuthState {
  user:     User | null
  session:  Session | null
  profile:  Profile | null
  loading:  boolean

  // Derived — always computed from profile, never stored separately
  role: UserRole

  setSession: (session: Session | null) => void
  setProfile:  (profile: Profile | null) => void
  setLoading:  (loading: boolean) => void
  reset:       () => void
}

/** Limpia estado Call Center persistido (localStorage) al cerrar sesión */
function clearCallCenterLocalState() {
  try {
    // Evita presencia/case residuales que puedan interferir al re-login
    localStorage.removeItem('crm-cc-workspace')
  } catch {
    /* ignore */
  }
}

export const useAuthStore = create<AuthState>()((set) => ({
  user:    null,
  session: null,
  profile: null,
  loading: true,
  role:    'agente', // safe default — least privilege

  setSession: (session) =>
    set({ session, user: session?.user ?? null }),

  setProfile: (profile) =>
    set({
      profile,
      // Sync role immediately when profile arrives — fixes sidebar permissions
      role: profile?.role ?? 'agente',
    }),

  setLoading: (loading) => set({ loading }),

  reset: () => {
    clearCallCenterLocalState()
    set({ user: null, session: null, profile: null, loading: false, role: 'agente' })
  },
}))
